/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DivideCircleIcon32Regular = forwardRef('DivideCircleIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M10 15a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H10Z" }),
        React.createElement("path", { d: "M17.498 10.498a1.498 1.498 0 1 1-2.997 0 1.498 1.498 0 0 1 2.997 0Z" }),
        React.createElement("path", { d: "M16 22.997A1.498 1.498 0 1 0 16 20a1.498 1.498 0 0 0 0 2.997Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3ZM5 16C5 9.925 9.925 5 16 5s11 4.925 11 11-4.925 11-11 11S5 22.075 5 16Z" })));
});
